import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Dialog, DialogContent, DialogContentText, IconButton, Button, } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { useState } from "react";
import AddAttachment from "./AddAttachment";
import { LoadingButton } from "@mui/lab";
import SendIcon from "@mui/icons-material/Send";
const AddMessageAttachmentDialog = () => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, { edge: "start", className: "add-attachment", onClick: handleOpen, sx: { mr: 1 }, children: _jsx(AttachFileIcon, {}) }), _jsx(Dialog, { className: "createNewMessage", open: isOpen, onClose: handleClose, fullWidth: true, children: _jsxs(DialogContent, { sx: { m: 4 }, children: [_jsx("h2", { children: "Add an Attachment" }), _jsx(DialogContentText, { children: _jsx(AddAttachment, {}) }), _jsxs("div", { className: "button-row", children: [_jsx(Button, { className: "btn-cancel", id: "cancel", sx: { p: 1.5, mt: 1 }, variant: "contained", onClick: handleClose, children: "Cancel" }), _jsx(LoadingButton, { type: "submit", id: "submit", sx: { p: 1.5, mt: 1 }, 
                                    // loading={isSubmitting}
                                    loadingPosition: "end", variant: "contained", startIcon: _jsx(SendIcon, {}), children: "Send Attachment" })] })] }) })] }));
};
export default AddMessageAttachmentDialog;
